import { createQueryKey } from 'common/store';
export var ChatPageApiTags;
(function (ChatPageApiTags) {
    ChatPageApiTags["ChatsList"] = "ChatsList";
    ChatPageApiTags["ChatMembers"] = "ChatMembers";
    ChatPageApiTags["ChatMessages"] = "ChatMessages";
})(ChatPageApiTags || (ChatPageApiTags = {}));
export var chatsListQueryKeys = createQueryKey(ChatPageApiTags.ChatsList);
export var chatMembersQueryKeys = createQueryKey(ChatPageApiTags.ChatMembers);
export var chatMessagesQueryKeys = createQueryKey(ChatPageApiTags.ChatMessages);
